import "./assets/css/Style.css";
import PublicRoutes from "./routes/PublicRoutes";
import "animate.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import { GetCampaign, GetSocialMedia } from "./network/Network";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  AllDonationCampaign,
  AllSocialLinks,
} from "./redux/actions/AuthActions";
import { GetSiteSettingsApi } from "./network/Network";
import { WebSiteSettings } from "./redux/actions/AuthActions";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    GetCampaign()
      .then((res) => {
        dispatch(AllDonationCampaign(res?.data));
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    GetSiteSettingsApi()
      .then((res) => {
        dispatch(WebSiteSettings(res?.data));
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    GetSocialMedia()
      .then((res) => {
        dispatch(AllSocialLinks(res?.data));
      })
      .catch((err) => {});
  }, []);

  return (
    <>
      <PublicRoutes />
      <ToastContainer />
    </>
  );
}

export default App;
